/**
 * Ist inzwischen ein neuerer Stand deployt als der, der hier läuft?
 *
 * Ein Präsentationsbildschirm bleibt tagelang offen. Ohne diese Prüfung läuft
 * dort der Code von vorgestern, während das Handy schon den neuen hat — und
 * Befehle, die der alte nicht kennt, gehen still daneben. Genau das ist mit
 * „Zum Chat" passiert.
 *
 * Verglichen wird die Hauptdatei, die die Seite lädt: Vite gibt ihr bei jedem
 * Build einen neuen Namen (`assets/index-<hash>.js`).
 */
export function hauptskript(html: string): string | null {
  return /\/assets\/index-[\w-]+\.js/.exec(html)?.[0] ?? null
}

export async function neuerStandDeployt(): Promise<boolean> {
  const laufend = hauptskript(document.documentElement.outerHTML)
  if (!laufend) return false
  // Mit Zeitstempel: Der Service Worker liefert sonst die gemerkte alte Seite.
  const res = await fetch(`/intro?stand=${Date.now()}`, { cache: 'no-store' })
  if (!res.ok) return false
  const deployt = hauptskript(await res.text())
  return deployt !== null && deployt !== laufend
}

/**
 * Lädt den neuen Stand. Erst den Service Worker aktualisieren — sonst liefert
 * er beim Neuladen noch einmal die alte Fassung aus seinem Speicher.
 */
export async function neuenStandLaden(): Promise<void> {
  try {
    const registrierung = await navigator.serviceWorker?.getRegistration()
    await registrierung?.update()
  } catch {
    // Ohne Service Worker lädt das Neuladen ohnehin frisch.
  }
  window.location.reload()
}
